import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog } from "../me/index.js";
import { RueckfrageGastgeber } from "./VerwerfenRueckfrage.js";
import { StrikteEbene, useImModal, useStrikteWege } from "./strikteHuelle.js";
export function Arbeitsdialog(p) {
    const imModal = useImModal();
    const { anker, steuerung } = useStrikteWege(p);
    /*
     * `unter="stapel"` fest: Liegt der Arbeitsdialog seinerseits über einem offenen Dialog,
     * kann ein vollflächiges Blatt nur darüber liegen, nie daneben.
     * Den Namen gibt das Element seiner Ebene aus dem Titel (wie beim `Modal`).
     */
    return (_jsx(StrikteEbene, { imModal: imModal, children: _jsxs(Dialog, { ref: steuerung, offen: true, strikt: true, art: "arbeit", breite: "voll", unter: "stapel", className: "ki-arbeitsdialog", titel: _jsx("span", { ref: anker, children: p.titel }), ...(p.pfad === undefined ? {} : { pfad: p.pfad }), steckbrief: p.steckbrief, meldungen: p.meldungen, register: p.register, hinweis: p.hinweis, fussLinks: p.fussLinks, fuss: p.fuss, children: [p.children, _jsx(RueckfrageGastgeber, {})] }) }));
}
//# sourceMappingURL=Arbeitsdialog.js.map